import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Sidebar from 'react-sidebar';
import axios from 'axios';
import _ from 'lodash';

import SidebarContent from '../../common/sidebar/SidebarContent';
import MobileHeader from '../common/header/MobileHeader';
import Loader from '../../common/loader/Loader';
import FooterMobile from '../common/footer/FooterMobile';

import { getCourseColor } from '../../../utils/course-utils';

import { getMobileSidebarStyles } from '../../../utils/sidebar-utils';

const typeToString = type => {
  switch (type) {
    case 1:
      return 'C#';
    case 2:
      return 'Javascript';
    case 3:
      return 'Typescript';
    case 4:
      return 'Nodejs';
    default:
      return 'Unknown';
  }
};

const getCourseImage = type => {
  switch (type) {
    case 1:
      return 'img/courses/csharp-white.svg';
    case 2:
      return 'img/courses/javascript-white.svg';
    case 3:
      return 'img/courses/typescript-white.svg';
    case 4:
      return 'img/courses/nodejs-white.svg';
    default:
      return 'Unknown';
  }
};

const userLevelToString = level => {
  switch (level) {
    case 1:
      return 'BEGINNER';
    case 2:
      return 'INTERMEDIATE';
    case 3:
      return 'ADVANCED';
    default:
      return 'ADVANCED';
  }
};

const CoursesListMobile = () => {
  const { isAuthenticated } = useSelector(state => state);
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState({});

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleSidebarOpen = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const closeSidebar = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    setIsLoading(true);
    axios
      .get('/api/v1/courses/published')
      .then(response => {
        setIsLoading(false);
        setCourses(_.groupBy(response.data.courses, x => typeToString(x.type)));
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  const navigateToCourse = id => () => {
    history.push(`/courses/${id}`);
  };

  return (
    <Sidebar
      open={isMenuOpen}
      onSetOpen={setIsMenuOpen}
      sidebar={<SidebarContent closeSidebar={closeSidebar} />}
      styles={getMobileSidebarStyles()}
    >
      <MobileHeader isAuthenticated={isAuthenticated} toggleSidebarOpen={toggleSidebarOpen} />
      <Loader isVisible={isLoading} />

      <div className="m-header-container">
        {_.map(courses, (list, key) => {
          return (
            <div key={key} className="mb-20px">
              <p className="m-courses-group">{key}</p>
              <div className="is-flex" style={{ flexWrap: 'wrap' }}>
                {list.map(course => {
                  return (
                    <div key={course._id} className="m-course-container" onClick={navigateToCourse(course._id)}>
                      <div className="m-course-header" style={{ background: getCourseColor(course.type) }}>
                        <div className="is-flex align-items-center">
                          <img src={getCourseImage(course.type)} width={33} />
                          <p className="m-course-type ml-10px">{key}</p>
                        </div>
                        <p>{course.webinarsCount} webinars</p>
                      </div>
                      <div className="m-course-body">
                        <p className="m-course-name">{course.name}</p>
                        <p>{course.description}</p>
                      </div>
                      <div className="m-course-footer">
                        <p>LEVEL: {userLevelToString(course.level)}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <FooterMobile />
    </Sidebar>
  );
};

export default CoursesListMobile;
